module.exports = "varying vec3 vNormal;\nvoid main()\n{\n  vNormal = normalize( normalMatrix * normal );\n  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/WoozyShaders/AlexGlow.vert
// module id = 358
// module chunks = 0